// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productListStyles } from "@conklin/Overrides/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationProductList";
import { xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

productListStyles.cartLineCardExpandedStyles = {
    cartLineContainer: {
        container: {
            css: css`
                ${({ includeActions }: any) =>
                    includeActions
                        ? "grid-template-columns: 91px minmax(45px,1fr) minmax(0,176px) minmax(0,129px) minmax(0,176px) minmax(34px, 38px);"
                        : "grid-template-columns: 91px minmax(45px,1fr) minmax(0,176px) minmax(0,129px) minmax(0,176px);"};

                ${xScreen("lte", "lg")} {
                    ${({ includeActions }: any) =>
                        includeActions
                            ? "grid-template-columns: 91px minmax(45px,1fr) minmax(0,148px) minmax(0,108px) minmax(0,148px) minmax(34px, 38px);"
                            : "grid-template-columns: 91px minmax(45px,1fr) minmax(0,148px) minmax(0,108px) minmax(0,148px);"};
                }
            `,
        },
    },
};

productListStyles.linesHeader = {
    wrapper: {
        css: css`
            ${({ includeActions }: any) =>
                includeActions
                    ? "grid-template-columns: 91px minmax(45px,1fr) minmax(0,176px) minmax(0,129px) minmax(0,176px) minmax(34px, 38px);"
                    : "grid-template-columns: 91px minmax(45px,1fr) minmax(0,176px) minmax(0,129px) minmax(0,176px);"};

            ${xScreen("lte", "lg")} {
                ${({ includeActions }: any) =>
                    includeActions
                        ? "grid-template-columns: 91px minmax(45px,1fr) minmax(0,148px) minmax(0,108px) minmax(0,148px) minmax(34px, 38px);"
                        : "grid-template-columns: 91px minmax(45px,1fr) minmax(0,148px) minmax(0,108px) minmax(0,148px);"};
            }
        `,
    },
};
